// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tft-notification{position:fixed;z-index:1000000}", "",{"version":3,"sources":["webpack://./src/components/common/tft-notification/style.scss"],"names":[],"mappings":"AAAA,kBACI,cAAA,CACA,eAAA","sourcesContent":[".tft-notification {\n    position: fixed;\n    z-index: 1000000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
